import { BaseBus } from "./BaseBus";

type GUID = string & { isGuid: true };
function guid(guid: string): GUID {
    return guid as GUID; // maybe add validation that the parameter is an actual guid ?
}
export class v_QuickSearchBus extends BaseBus
{
    constructor(busObj: v_QuickSearchBus = null) {
        super(busObj);

        if (busObj && busObj.rcvdDt) { this.rcvdDt = new Date(busObj.rcvdDt)}

        //this.cpIconClass = this.computeCPIconClass();
    } 
    dispatchId: any;
    customerName: string;
    locationName: string;
    dispatchNumber: string;
    woNumber: string;
    poNumber: string;
    receivedDateTime: Date;
    dispatchStatusName: string;
    dispatchReason: string;
    //quoteNumber: string;
    //quickSearchKey: string;
    //invoiceNumber: string;
    //city: string;
    //isOpen: boolean;patchId: any;
    id: GUID;
    nbr: string;
    wo: string;
    rcvdDt: Date;
    sts: string;
    pri: string;
    cus: string;
    loc: string;
    reason: string;
    refNbr: string;
    buyer: string;
    rqstr: string;
    hasCC: boolean;
    mfgNbrs: string;
    supplierNbrs: string;
    isConstruction: boolean;
    domainAvailability: string;
    //cpIconClass?: string;
    //zgIconClass?: string = "fa-climate-pros";

    //private computeCPIconClass(): string {
    //    if ( this.isConstruction ) {
    //        return 'fas fa-hard-hat';
    //    } else {
    //        return 'fas fa-phone';
    //    }
    //}
}
